import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const CLUSTERS_EFFICIENCY_SUMMARY_QUERY_KEY = 'clusters-efficiency-summary';

const getClustersEfficiencySummaryQueryKey = (
  startTime: string,
  endTime: string,
  useListingPrices: boolean
) =>
  [
    CLUSTERS_EFFICIENCY_SUMMARY_QUERY_KEY,
    startTime,
    endTime,
    useListingPrices,
  ] as const;

type UseClustersEfficiencySummaryQueryQueryArgs = {
  startTime: string;
  endTime: string;
  useListingPrices: boolean;
  enabled?: boolean;
};

const getClustersEfficiencySummaryQueryOptions = ({
  startTime,
  endTime,
  useListingPrices,
  enabled = true,
}: UseClustersEfficiencySummaryQueryQueryArgs) =>
  queryOptions({
    queryKey: getClustersEfficiencySummaryQueryKey(
      startTime,
      endTime,
      useListingPrices
    ),
    queryFn: async () => {
      const { data } =
        await apiClient.costReport.getOrganizationClustersEfficiencySummary({
          startTime,
          endTime,
          useListingPrices,
        });

      return data;
    },
    enabled,
  });

export const useClustersEfficiencySummaryQuery = (
  args: UseClustersEfficiencySummaryQueryQueryArgs
) => {
  const { data, isLoading, error, refetch } = useQuery(
    getClustersEfficiencySummaryQueryOptions(args)
  );

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
